import Peer from '@/store/models/Peer'

const defaultState = () => {
  return {
    peers: [],
    removePeerId: null
  }
}

const state = defaultState()

const getters = {
  peers: state => state.peers,
  removePeerId: state => state.removePeerId,
  aboriginalPeers: state => state.peers.filter(peer => peer.aboriginal),
  peerById: state => id => {
    return state.peers.filter(peer => peer.id == id)[0]
  }
}

const mutations = {
  setPeer(state, payload) {
    const newPeer = new Peer(payload)

    // setPeerHandler
    newPeer.on('close', () => {
      this.commit('peers/removePeer', newPeer.id)
    })

    state.peers.push(newPeer)
    return newPeer
  },
  removePeer(state, peerId) {
    state.removePeerId = peerId
    state.peers = state.peers.filter(peer => peer.id !== peerId)
  },
  resetModule(state) {
    Object.assign(state, defaultState())
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
